export const strings = {
  didYouKnowSettingsMessage: 'System Administrators can change application wide settings from here.',
  noSettingsFound: 'No settings found.',
  noSettingValue: 'No value.',
  settingNameHeader: 'Name',
  settingValueHeader: 'Value',
  settingsSaved: 'Settings have been saved successfully.',
  updatedDetailsHeader: 'Last Updated Details',
};